module.exports = __webpack_public_path__ + "img/bolsa_de_valores_de_lima.a62be0e9.png";